import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { clearGuestSession, initGuestSession } from "./guestSlice";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    user: null,
    authReady: false,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken } = action.payload;
      state.token = accessToken;
      const decoded = jwtDecode(accessToken);
      state.user = { ...decoded };
      // 🔹 Clear guest session once real login happens
      if (action.asyncDispatch) {
        action.asyncDispatch(clearGuestSession());
      }
    },
    logout: (state, action) => {
      state.token = null;
      state.user = null;
      state.tempAuth = null;

      // 🔹 Clear old guest session if any
      if (action.asyncDispatch) {
        action.asyncDispatch(clearGuestSession());
        // 🔹 Immediately re-init a new guest session
        action.asyncDispatch(initGuestSession());
      }
    },
    setAuthReady: (state, action) => {
      state.authReady = action.payload;
    },
  },
});

export const { setCredentials, logout, setAuthReady } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentRoles = (state) => state.auth.user?.roles || [];
// export const selectCurrentUserRoles = (state) => state.auth.user?.roles || [];
export const selectAuthReady = (state) => state.auth.authReady;
